module.exports = __webpack_public_path__ + "static/img/spiral.4ce28319.png";